export const initUnitOfMeasure = {
  id: "",
  tenancyId: "",
  name: "",
  shortName: "",
  description: "",
  translations: [],
}
